import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/tochless/tochless-page-banner.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {motion, useInView} from "framer-motion";
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import "./tochless.scss"
import sec2b1 from "../../../../../assets/website-images/product/tochless/sec2-img-1.png"
import sec2b2 from "../../../../../assets/website-images/product/tochless/sec2-img-2.png"
import sec1Img from "../../../../../assets/website-images/product/tochless/sec-1.png";
import bio1 from "../../../../../assets/website-images/product/tochless/sec-3-1.png";
import bio2 from "../../../../../assets/website-images/product/tochless/sec-3-2.png";
import bio3 from "../../../../../assets/website-images/product/tochless/sec-3-3.png";
import bio4 from "../../../../../assets/website-images/product/tochless/sec-3-4.png";
import sec4box1 from "../../../../../assets/website-images/product/tochless/sec-4-1.png";
import sec4box2 from "../../../../../assets/website-images/product/tochless/sec-4-2.png";
import sec4box3 from "../../../../../assets/website-images/product/tochless/sec-4-3.png";
import sec4box4 from "../../../../../assets/website-images/product/tochless/sec-4-4.png";
import sec4box5 from "../../../../../assets/website-images/product/tochless/sec-4-5.png";
import sec4box6 from "../../../../../assets/website-images/product/tochless/sec-4-6.png";
import sec5box1 from "../../../../../assets/website-images/product/tochless/sec-5-1.png"
import sec5box2 from "../../../../../assets/website-images/product/tochless/sec-5-2.png"
import sec5box3 from "../../../../../assets/website-images/product/tochless/sec-5-3.png"
import sec6box1 from "../../../../../assets/website-images/product/tochless/sec-6-1.png"
import sec6box2 from "../../../../../assets/website-images/product/tochless/sec-6-2.png"
import sec6box3 from "../../../../../assets/website-images/product/tochless/sec-6-3.png"
import sec6box4 from "../../../../../assets/website-images/product/tochless/sec-6-4.png"
import sec7 from "../../../../../assets/website-images/product/tochless/sec-7-1.png"
import {useTranslation} from "react-i18next";

export default function TochlessPage() {
    const {t} = useTranslation();
    const ref2 = useRef(null);
    const ref5 = useRef(null);
    const isInView2 = useInView(ref2, { once: true });
    const isInView5 = useInView(ref5, { once: true });
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'tochless'}>
            <PageBanner img={productPageImg} heading={t('products.touchless_biomatric.banner_head')} bannerImg={productBannerImg}/>
            <div className={'section-1'}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <h3 className={'heading'}>{t('products.touchless_biomatric.section_1.head')}</h3>
                            <p>{t('products.touchless_biomatric.section_1.para')}</p>
                        </Col>
                        <Col lg={6} className={'text-center'}>
                            <img src={sec1Img} className={'img-fluid ms-auto'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-2'}>
                <Container>
                    <Row>
                        <Col lg={7}>
                            <h2 className={'heading'}>{t('products.touchless_biomatric.section_2.head')}</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <div className={'sec2-box'}>
                                <div className={'img'}>
                                    <img src={sec2b1}/>
                                </div>
                                <div className={'content'}>
                                    <h4>{t('products.touchless_biomatric.section_2.box_1.head')}</h4>
                                    <p>{t('products.touchless_biomatric.section_2.box_1.para')}</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className={'text-center'}>
                            <div className={'sec2-box'}>
                                <div className={'img'}>
                                    <img src={sec2b2}/>
                                </div>
                                <div className={'content'}>
                                    <h4>{t('products.touchless_biomatric.section_2.box_2.head')}</h4>
                                    <p>{t('products.touchless_biomatric.section_2.box_2.para')}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="home-featured-products">
                <Container>
                    <Row>
                        <Col>
                            <div ref={ref2}>
                                <motion.h2
                                    className={'heading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('products.touchless_biomatric.section_3.head')}
                                </motion.h2>
                            </div>

                            <div className="cards" ref={ref5}>
                                <Row>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 1 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio1}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4>{t('products.touchless_biomatric.section_3.box_1.head')}</h4>
                                                        <p>
                                                            {t('products.touchless_biomatric.section_3.box_1.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 2 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio2}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4> {t('products.touchless_biomatric.section_3.box_2.head')}</h4>
                                                        <p>
                                                            {t('products.touchless_biomatric.section_3.box_2.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 3 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio3}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4> {t('products.touchless_biomatric.section_3.box_3.head')}</h4>
                                                        <p>
                                                            {t('products.touchless_biomatric.section_3.box_3.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div style={{display: "flex"}}
                                                    className="product-card"
                                                    initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                                    animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                                    transition={{ duration: 1.4, delay: 4 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio4}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4> {t('products.touchless_biomatric.section_3.box_4.head')}</h4>
                                                        <p>
                                                            {t('products.touchless_biomatric.section_3.box_4.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-4'}>
                <Container>
                    <Row>
                        <h2 className={'heading'}> {t('products.touchless_biomatric.section_4.head')}</h2>
                    </Row>
                    <Row>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box1}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_1.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_1.para')}</p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box2}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_2.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_2.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box3}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_3.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_3.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box4}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_4.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_4.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box5}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_5.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_5.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec4box6}/>
                                <h4> {t('products.touchless_biomatric.section_4.box_6.head')} </h4>
                                <p> {t('products.touchless_biomatric.section_4.box_6.para')}</p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-5'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <h2 className={'heading'}>{t('products.touchless_biomatric.section_5.head')}</h2>
                        </Col>
                        <Col lg={12}>
                            <ul>
                                <li>
                                    <div className={'sec5-box'}>
                                        <img src={sec5box1}/>
                                        <div className={'content'}>
                                            <h4>{t('products.touchless_biomatric.section_5.box_1.head')}</h4>
                                            <p>{t('products.touchless_biomatric.section_5.box_1.para')}</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={'sec5-box'}>
                                        <img src={sec5box2}/>
                                        <div className={'content'}>
                                            <h4>{t('products.touchless_biomatric.section_5.box_2.head')}</h4>
                                            <p>{t('products.touchless_biomatric.section_5.box_2.para')}</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={'sec5-box'}>
                                        <img src={sec5box3}/>
                                        <div className={'content'}>
                                            <h4>{t('products.touchless_biomatric.section_5.box_3.head')}</h4>
                                            <p>{t('products.touchless_biomatric.section_5.box_3.para')}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-6'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className={'heading-section'}>
                                <h2 className={'heading'}>{t('products.touchless_biomatric.section_6.head')}</h2>
                                <h4 className={'subheading'}>{t('products.touchless_biomatric.section_6.sub_head')}</h4>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} xl={3}>
                            <div className={'sec6-box'}>
                                <img src={sec6box1}/>
                                <h4>{t('products.touchless_biomatric.section_6.box_1.head')}</h4>
                                <p>{t('products.touchless_biomatric.section_6.box_1.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} xl={3}>
                            <div className={'sec6-box'}>
                                <img src={sec6box2}/>
                                <h4>{t('products.touchless_biomatric.section_6.box_2.head')}</h4>
                                <p>{t('products.touchless_biomatric.section_6.box_2.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} xl={3}>
                            <div className={'sec6-box'}>
                                <img src={sec6box3}/>
                                <h4>{t('products.touchless_biomatric.section_6.box_3.head')}</h4>
                                <p>{t('products.touchless_biomatric.section_6.box_3.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} xl={3}>
                            <div className={'sec6-box'}>
                                <img src={sec6box4}/>
                                <h4>{t('products.touchless_biomatric.section_6.box_4.head')}</h4>
                                <p>{t('products.touchless_biomatric.section_6.box_4.para')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'product-section'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={5} className={'text-center'}>
                            <img src={sec7} className={'img-fluid'}/>
                        </Col>
                        <Col lg={7} className={'d-flex align-items-center'}>
                            <div>
                                <p>{t('products.touchless_biomatric.section_7.para')}</p>
                                <h5 className={'subheading'}>{t('products.touchless_biomatric.section_7.sub_head')}</h5>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}